import FormMultiselect from './form-multiselect.jsx';

export default FormMultiselect;
